import { NEWSLETTERS } from 'cio/utils/broadcasts';
import { CampaignType } from 'cio/models/campaign';

export interface SegmentUsageItem {
  id: string;
  name: string;
  type: CampaignType | 'newsletter' | 'sql_import';
  updated: number;
  recipients?: boolean;
  trigger?: boolean;
  filter?: boolean;
  staticSegUpdates?: boolean;
  archived?: boolean;
}

export interface SegmentUsage {
  draftNewsletters: SegmentUsageItem[];
  sentNewsletters: SegmentUsageItem[];
  campaigns: SegmentUsageItem[];
  broadcasts: SegmentUsageItem[];
  sqlImports: SegmentUsageItem[];
  dashboard: SegmentUsageItem[];

  newsletters: SegmentUsageItem[];
}
export enum SegmentUsageIdTypes {
  ConditionTriggered = 'condition-triggered',
  EventTriggered = 'event-triggered',
  Campaign = 'campaign',
  ApiTriggered = 'api-triggered',
  Newsletter = 'newsletter',
  Dashboard = 'dashboard',
  SQLImport = 'sql-import',
}

export type SEGMENT_USAGE_TYPE = {
  id: SegmentUsageIdTypes;
  title: string;
  shortTitle?: string;
  icon: string;
  routeName: string;
  newRouteName?: string;
  newRouteQuery?: Record<string, string>;
};

export const TYPE_CONDITION_TRIGGERED: SEGMENT_USAGE_TYPE = {
  id: SegmentUsageIdTypes.ConditionTriggered,
  title: 'Condition Triggered Campaign',
  icon: 'trigger-segment',
  routeName: 'campaigns.campaign',
  newRouteName: 'campaigns.new',
};

export const TYPE_CAMPAIGN: SEGMENT_USAGE_TYPE = {
  id: SegmentUsageIdTypes.Campaign,
  title: 'Campaign',
  icon: 'campaigns',
  routeName: 'campaigns.campaign',
  newRouteName: 'campaigns.new',
};

export const TYPE_EVENT_TRIGGERED: SEGMENT_USAGE_TYPE = {
  id: SegmentUsageIdTypes.EventTriggered,
  title: 'Event Triggered Campaign',
  icon: 'trigger-event',
  routeName: 'campaigns.campaign',
  newRouteName: 'campaigns.new',
};

export const TYPE_NEWSLETTER: SEGMENT_USAGE_TYPE = {
  id: SegmentUsageIdTypes.Newsletter,
  title: 'Newsletter',
  icon: 'newsletter',
  routeName: 'broadcasts.newsletter',
  newRouteName: 'broadcasts.new',
  newRouteQuery: { type: NEWSLETTERS },
};

export const TYPE_BROADCAST: SEGMENT_USAGE_TYPE = {
  id: SegmentUsageIdTypes.ApiTriggered,
  title: 'API Triggered Broadcast',
  shortTitle: 'Broadcast',
  icon: 'api-triggered-broadcast',
  routeName: 'broadcasts.broadcast',
  newRouteName: 'broadcasts.new',
  newRouteQuery: { type: CampaignType.APITriggered },
};

export const TYPE_DASHBOARD: SEGMENT_USAGE_TYPE = {
  id: SegmentUsageIdTypes.Dashboard,
  title: 'Dashboard',
  icon: 'dashboard',
  routeName: 'Dashboard',
};

export const TYPE_SQL_IMPORT: SEGMENT_USAGE_TYPE = {
  id: SegmentUsageIdTypes.SQLImport,
  title: 'SQL Sync',
  icon: 'database',
  routeName: 'sql-import',
  newRouteName: 'integrations',
  newRouteQuery: { query: 'sql', selectedCategory: 'Databases' },
};
